import React from 'react'

const KAKAO_AUTH_GUIDE_SRC = `${process.env.PUBLIC_URL || ''}/static-assets/health/kakao-simple-auth-guide.png`

function AuthGuidePanel({ className = '' }) {
  return (
    <section
      className={`relative aspect-[682/1024] w-full overflow-hidden border-b border-slate-100 lg:border-b-0 ${className}`.trim()}
    >
      <img
        src={KAKAO_AUTH_GUIDE_SRC}
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-center"
        loading="lazy"
      />
      <div className="absolute inset-x-0 top-0 z-10 p-4 text-center lg:p-5">
        <h3 className="text-xl font-bold text-black">
          간편인증 안내
        </h3>
      </div>
    </section>
  )
}

/**
 * 좌: 인증 고객 정보 + 필수 동의 / 우: 카카오 간편인증 안내
 */
export default function HealthIntakeFormLayout({
  serviceLabel,
  quotaSlot,
  onSubmit,
  identityPanel,
  consentPanel,
  footerActions,
}) {
  return (
    <div className="mx-auto w-full max-w-5xl">
      <div className="mb-5 space-y-3">
        <div className="flex flex-wrap items-center gap-2 text-xs font-medium text-slate-500">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-brand-navy/20 bg-sky-50 px-2.5 py-1 text-brand-navy">
            <span className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-brand-navy text-[10px] text-white">1</span>
            고객 정보 · 동의
          </span>
          <span className="text-slate-300">→</span>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-2.5 py-1 text-slate-600">
            <span className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-slate-200 text-[10px] text-slate-700">2</span>
            간편인증
          </span>
        </div>
        <div>
          <h2 className="text-lg font-semibold text-slate-900">간편 인증 조회</h2>
          {serviceLabel ? (
            <p className="mt-1 text-sm text-slate-600">{serviceLabel}</p>
          ) : null}
          <p className="mt-2 text-sm text-slate-500">
            고객 정보와 필수 동의를 확인한 뒤 조회를 시작해 주세요.
          </p>
        </div>
        {quotaSlot}
      </div>

      <form
        onSubmit={onSubmit}
        className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm"
      >
        <div className="grid lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:items-start">
          <section className="space-y-4 border-b border-slate-100 p-6 lg:border-b-0 lg:border-r">
            <h3 className="text-base font-semibold text-slate-900">인증 고객 정보</h3>
            {identityPanel}
            {consentPanel ? (
              <div className="border-t border-slate-100 pt-4">
                {consentPanel}
              </div>
            ) : null}
          </section>
          <AuthGuidePanel />
        </div>
        {footerActions ? (
          <div className="flex flex-wrap gap-2 border-t border-slate-100 bg-white px-6 py-4">
            {footerActions}
          </div>
        ) : null}
      </form>
    </div>
  )
}
